import { connect } from 'react-redux';
// import {  } from '../reducers/auth.reducers';
import { updateNotificationEntryStateAction, setNotificationStates } from '../../reducers/notification.reducers';
import NotificationCenter from './notification-center';

const mapDispatchToProps = dispatch => ({
  updateState: states => dispatch(updateNotificationEntryStateAction(states)),
  setNotificationStates: states => dispatch(setNotificationStates(states)),
});

const mapStateToProps = state => ({
  notifications: state.notification.notificationCenterEntries,
});

export default connect(mapStateToProps, mapDispatchToProps)(NotificationCenter);



// WEBPACK FOOTER //
// ./src/app/main/notification-center/notification-center.container.js